import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function MaskedLines({ lines, className = "", delay = 0, as: Tag = "h1" }) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-1">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Reveal({ children, className = "", delay = 0, y = 20 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -5% 0px" }}
      transition={{ duration: 0.6, delay: Math.min(delay, 0.25), ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children }) {
  return (
    <p className="font-mono text-xs uppercase tracking-[0.25em] font-semibold text-ember">
      {children}
    </p>
  );
}

export function PageHero({ eyebrow, lines, sub }) {
  return (
    <section className="relative overflow-hidden border-b border-slate-200 bg-white">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(2,132,199,0.08),transparent_55%),radial-gradient(ellipse_at_bottom_left,rgba(234,88,12,0.07),transparent_55%)]" />
      <div className="relative px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-24 lg:py-32">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
        </Reveal>
        <MaskedLines
          lines={lines}
          delay={0.1}
          className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.04] text-navy max-w-4xl"
        />
        {sub && (
          <Reveal delay={0.45}>
            <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-600">{sub}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
